const START_LOADING: string = 'loading/START_LOADING' as const;
const END_LOADING:   string = 'loading/END_LOADING'   as const;

type startLoadingAction = {
    type: typeof START_LOADING;
};
type endLoadingAction = {
    type: typeof END_LOADING;
};

type ActionType = startLoadingAction | endLoadingAction;

export const startLoading = () => ({type : START_LOADING});
export const endLoading   = () => ({type : END_LOADING});

interface InitialStateType {
    state: boolean;
};

const initialState: InitialStateType = {
    state: false,
};

export default function loading(state: InitialStateType = initialState, action: ActionType) {
    switch(action.type) {
        case START_LOADING:
            return {
                state: true,
            };
        case END_LOADING:
            return {
                state: false,
            }
        default:
            return state;
    }
}